import React, { Fragment, useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectOrganisation, selectOrganisationSites } from '../../../../../redux/selectors/organisation';
import AddorEditSiteModal from './AddOrEditSiteModal';
// import DeleteSiteModal from './DeleteSiteModal';
import SquareDelete from '../../../../../components/SquareDelete/SquareDelete';
import SquareEdit from '../../../../../components/SquareEdit/SquareEdit';
// import SquareEdit from '../../../../../components/SquareEdit/SquareEdit';
import Table from '../../../../../components/Table/Table';
import {
  doDeleteOrganisationSite,
  doReadOrganisationSites,
} from '../../../../../redux/thunks/organisation';
import { selectCurrentPartner } from '../../../../../redux/selectors/authentication';
import { useParams } from 'react-router-dom';
import { Search } from '../../../../../utils/Search';
import useBreakpoint from '../../../../../hooks/useBreakpoint';
import Button from '../../../../../components/Buttons/Button';
import ViewNetworks from './ViewNetworks/ViewNetworks';
import useIsMobile from '../../../../../hooks/useIsMobile';
import MobileTable from '../../../../../components/MobileTable/MobileTable';
import FlexRow from '../../../../../components/FlexBox/FlexRow';
import SButton from '../../../../../components/SButton/SButton';
import Typography from '../../../../../components/Typography/Typography';
import SDialog from '../../../../../components/SDialog/SDialog';

const SiteTab = () => {

  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const [popupTitle, setPopupTitle] = useState('Add');
  const [showSitePopup, setShowSitePopup] = useState(false);
  const [showNetworksView, setShowNetworksView] = useState(false);
  const [showDeleteSitePopup, setShowDeleteSitePopup] = useState(false);
  const [site, setSite] = useState(null);
  const [filters, setFilters] = useState({ id: '', name: '', location: '', timezone: '' });
  const [pagination, setPagination] = useState({ total: 0, currentPage: 1, perPage: 7 });

  const { customerId } = useParams();

  const { sites, currentUser, organisation } = useSelector((state) => ({
    sites: selectOrganisationSites(state),
    currentUser: selectCurrentPartner(state),
    organisation: selectOrganisation(state),
  }));

  useEffect(() => {
    setPagination(prev => ({ ...prev, total: sites?.length ? sites?.length : 0 }));
  }, [sites?.length, setPagination]);

  const columns = useMemo(() => {
    const commonColumns = [
      {
        title: 'Id',
        field: 'id',
        name: 'id',
      },
      {
        title: 'Site Name',
        field: 'name',
        name: 'name',
      },
      {
        title: 'Site Location',
        field: 'location',
        name: 'location',
      },
      {
        title: 'Networks',
        field: 'networks',
        // name: 'networks',
        render: (columnProps, rowData) => {
          return (
            <FlexRow width='fit-content'>
              <p>{rowData?.networks?.length.toString().padStart(2, '0')}</p>
              <SButton
                style={{ padding: '0.1rem 1rem' }}
                variant={"secondary"}
                color={"info"}
                onClick={() => {
                  setSite(rowData);
                  togglePopup('View');
                }}
              >View</SButton>
            </FlexRow>
          );
        },
        renderM: (columnProps, rowData) => {
          return (
            <FlexRow width='fit-content'>
              <p>{rowData?.networks?.length.toString().padStart(2, '0')}</p>
              <SButton
                style={{ padding: '0.1rem 1rem' }}
                variant={"secondary"}
                color={"info"}
                onClick={() => {
                  setSite(rowData);
                  togglePopup('View');
                }}
              >View</SButton>
            </FlexRow>
          );
        },
      },
      {
        title: 'Time zone',
        field: 'timezone',
        name: 'timezone',
        // name: 'timezone',
      },
    ];

    const actions = [
      {
        title: 'Action',
        render: (columnProps, rowData) => {
          return (
            <FlexRow justifyContent='end' gap='0.5rem'>
              {organisation?.integrationLevel !== 1 && <SquareEdit
                color={'#ff535a'}
                onPress={() => {
                  setPopupTitle('Edit');
                  togglePopup('AddOrEditSite');
                  setSite(rowData);
                  // togglePopup('AddOrEditAccessPoint');
                }}
                style={{ height: '2rem', width: '2rem' }}
              />}
              <SquareDelete
                color={'#ff535a'}
                onPress={(e) => {
                  // deleteMesh(rowData.serialNumber);
                  setSite(rowData);
                  togglePopup('DeleteSite');
                }}
                style={{ height: '2rem', width: '2rem', padding: '0px' }}
              />
            </FlexRow>
          );
        },
        renderM: (columnProps, rowData) => {
          return (
            <FlexRow justifyContent='end' gap='0.5rem'>
              {organisation?.integrationLevel !== 1 && <SquareEdit
                color={'#ff535a'}
                onPress={() => {
                  setPopupTitle('Edit');
                  togglePopup('AddOrEditSite');
                  setSite(rowData);
                  // togglePopup('AddOrEditAccessPoint');
                }}
                style={{ height: '2rem', width: '2rem' }}
              />}
              <SquareDelete
                color={'#ff535a'}
                onPress={(e) => {
                  // deleteMesh(rowData.serialNumber);
                  setSite(rowData);
                  togglePopup('DeleteSite');
                }}
                style={{ height: '2rem', width: '2rem', padding: '0px' }}
              />
            </FlexRow>
          );
        },
        props: {
          head: {
            style: {
              textAlign: 'center',
            }
          }
        }
      },
    ]

    return {
      allColumns: [...commonColumns, ...actions],
      commonColumns,
      actions
    }

  }, [])

  const mobileFiltersConfig = useMemo(() => {
    return [
      { name: "Site Name", key: "name", type: "search" },
      { name: "ID", key: "id", type: "search" },
      { name: "Site Location", key: "location", type: "search" },
      { name: "Time Zone", key: "timezone", type: "search" },
    ]
  }, [])

  const togglePopup = (popupName) => {
    if (popupName === 'AddOrEditSite') {
      setShowSitePopup(!showSitePopup);
      if (showSitePopup) {
        setSite(null);
      }
    }

    if (popupName === 'DeleteSite') {
      setShowDeleteSitePopup(!showDeleteSitePopup);
      if (showDeleteSitePopup) {
        setSite(null);
      }
    }
    if (popupName === 'View') {
      setShowNetworksView(!showNetworksView);
      if (showNetworksView) {
        setSite(null);
      }
    }
  };

  const point = useBreakpoint();

  useEffect(() => {
    if (currentUser) {
      dispatch(
        doReadOrganisationSites({
          partnerId: currentUser.partnerId,
          organisationId: customerId,
          displayNotification: false,
        }),
      );
    }
  }, [dispatch, point, currentUser, customerId]);

  //table
  const hSearchChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const search = {
    onChange: hSearchChange,
  };

  const filteredData = useCallback(() => {
    let data = sites ? sites : [];
    if (filters.id !== '') {
      data = Search(data, 'id', filters.id);
    }

    if (filters.location !== '') {
      data = Search(data, 'location', filters.location);
    }

    if (filters.name !== '') {
      data = Search(data, 'name', filters.name);
    }

    if (filters.timezone !== '') {
      data = Search(data, 'timezone', filters.timezone);
    }

    if (!isMobile) {
      data = data.slice(
        (pagination.currentPage - 1) * 7,
        pagination.currentPage * pagination.perPage,
      );
    }

    return data;
  }, [
    filters.id,
    filters.location,
    filters.name,
    filters.timezone,
    pagination.currentPage,
    pagination.perPage,
    sites,
    isMobile
  ]);

  const changePage = (p) => {
    const { page, per_page } = p;
    setPagination(prev => ({
      ...prev,
      currentPage: page,
      perPage: per_page
    }));
  };

  const handleDeleteSite = () => {
    dispatch(
      doDeleteOrganisationSite({
        partnerId: currentUser.partnerId,
        organisationId: customerId,
        siteId: site.id,
        siteName: site.name,
      }),
    );
    setSite(null);
    setShowDeleteSitePopup(false);
  };

  return (
    <Fragment>
      <div className="spacer__1" />
      <div>
        <div>
          {showNetworksView && (
            <ViewNetworks
              {...{ site, togglePopup, showNetworksView, onClose: () => togglePopup('View') }}
            />
          )}
          {showSitePopup && (
            <AddorEditSiteModal
              {...{
                popupTitle,
                showSitePopup,
                togglePopup,
                site,
                setSite,
                mode: popupTitle?.toLocaleLowerCase(),
                onClose: () => togglePopup('AddOrEditSite'),
              }}
            />
          )}
          {showDeleteSitePopup && (
            <SDialog
              title='Delete Site'
              open={showDeleteSitePopup}
              onClose={() => {
                setShowDeleteSitePopup(false);
              }}
              secondaryButtonConfig={{
                text: 'Cancel',
                onClick: () => {
                  setShowDeleteSitePopup(false);
                }
              }}
              primaryButtonConfig={{
                text: 'Delete',
                color: 'error',
                onClick: handleDeleteSite
              }}
            >
              <Typography variant={"b1M"} style={{ padding: '1.5rem 0' }}>Are you sure you want to delete {site ? site.name : ''} ? This action is non
                reversible and will cause you to lose all data associated with this site/ s</Typography>
            </SDialog>
          )}
          <FlexRow justifyContent='space-between' styles={{ marginBottom: '1rem' }}>
            <Typography variant={"h7M"}>Sites</Typography>
            {organisation?.integrationLevel !== 1 && <SButton
              minWidth
              onClick={() => {
                setPopupTitle('Add');
                togglePopup('AddOrEditSite');
              }}
            >
              Add Sites
            </SButton>}
          </FlexRow>
          <div>
            {isMobile ?
              <MobileTable
                columns={columns?.commonColumns}
                data={filteredData()}
                actions={columns?.actions}
                filtersConfig={mobileFiltersConfig}
                filters={filters}
                setFilters={setFilters}
                emptyMessage="No Sites found"
              />
              : <Table
                columns={columns?.allColumns}
                data={filteredData()}
                options={{ search }}
                pagination={pagination}
                changePage={changePage}
                defaultMessage="No Sites found"
              />}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SiteTab;
